import React from 'react';
import { IntakeForm } from './components/IntakeForm';
export function App() {
  return <IntakeForm data-id="element-0" data-mp="35ckb29dc16k1" />;
}